module.exports = __webpack_public_path__ + "img/whiteBrandLogoLight.3f541dcf.png";